import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Angular is a complete, opinionated framework maintained by Google for building large single-page applications. Its component architecture, dependency injection and strong TypeScript foundation make big front ends easier to reason about and safer to change.",
    "We use Angular where an application needs structure at scale — rich dashboards, admin tools and enterprise portals — delivering clean, testable code that a team can grow with for years.",
];

const FEATURES = [
    { title: "Component architecture", text: "Reusable, self-contained components keep complex interfaces organised and consistent." },
    { title: "Two-way data binding", text: "The view and the model stay in sync automatically, cutting boilerplate and bugs." },
    { title: "TypeScript first", text: "Static typing catches errors early and makes large codebases far easier to maintain." },
    { title: "Built-in tooling", text: "Routing, forms, HTTP and testing come out of the box, so teams move faster from day one." },
];

const CHECKS = [
    "Enterprise web apps",
    "Admin dashboards & portals",
    "Progressive web apps",
    "Single-page applications",
    "Migration from legacy front ends",
];

export default function Angularjs() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="Angular Development" eyebrowAs="span">
                    Structured, maintainable single-page applications built with Angular — Google's TypeScript framework for ambitious front ends.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
